import React, { useEffect } from "react";
import "../CSS/Style.css";
import axios from "axios";
import Header from "./Header";
import AssignTicket from './UnassignedTickets'

const Ticket = () => {

  useEffect(() => {
    let storedToken = sessionStorage.getItem("token");
    let storedEmail = sessionStorage.getItem("email");

    if (!storedToken || !storedEmail) {
        window.location.href = "/signin";
    } else {
        const config = { headers: { Authorization: `Bearer ${storedToken}` } };
        axios.get("https://api.mahirefrigeration.com/api/validateToken", config)
            .then((res) => {
                if (res.data === "User validation failed") {
                    sessionStorage.clear();
                    window.location.href = "/signin";
                }
                else{
                }
            });
    }
  }, []);

  return (
    <>
      <Header />
      <div className="first_sec_ran">
      <div className="container mt-5" style={{ display: "flex", gap: "20px", flexWrap: "wrap"}}>
        <AssignTicket/>
      </div>
      </div>
    </>
  );
};

export default Ticket;
